module.exports = __webpack_public_path__ + "static/media/stringz_bg@2x.e19892ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/stringz_bg@2x.png
// module id = 440
// module chunks = 0